/**
 * Urdu Translations
 */

import type { DashboardTranslations } from './types'

export const urTranslations: DashboardTranslations = {
  overview: 'جائزہ',

  balance: {
    title: 'دستیاب بیلنس',
    creditLimit: 'کریڈٹ کی حد',
    available: 'دستیاب',
    used: 'استعمال شدہ',
    wallet: 'والیٹ',
  },

  orders: {
    title: 'کل آرڈرز',
    pending: 'زیر التواء',
    processing: 'پروسیسنگ',
    delivered: 'ڈیلیور شدہ',
    total: 'کل',
  },

  deliveries: {
    title: 'ڈیلیور شدہ مصنوعات',
    tons: 'ٹن',
    count: 'ڈیلیوری',
    accepted: 'قبول شدہ',
    pending: 'زیر التواء',
  },

  summary: {
    totalQuantity: 'کل مقدار',
    cities: 'شہر',
    customers: 'کسٹمرز',
    orders: 'آرڈرز',
  },

  pending: {
    title: 'لینے کے منتظر',
    processing: 'پروسیسنگ',
    awaiting: 'لینے کے منتظر',
  },

  pendingDeliveries: {
    title: 'زیر التواء ڈیلیوریز',
    accepted: 'قبول شدہ',
    awaiting: 'منظوری کے منتظر',
  },

  dateRange: {
    today: 'آج',
    thisWeek: 'اس ہفتے',
    thisMonth: 'اس مہینے',
    thisQuarter: 'اس سہ ماہی',
    thisYear: 'اس سال',
    last30Days: 'گزشتہ 30 دن',
    custom: 'اپنی مرضی کی رینج',
    from: 'سے',
    to: 'تک',
  },

  error: {
    loadFailed: 'ڈیش بورڈ ڈیٹا لوڈ کرنے میں ناکام۔ براہ کرم دوبارہ کوشش کریں۔',
    refreshFailed: 'ڈیش بورڈ ڈیٹا ریفریش کرنے میں ناکام۔',
  },

  chart: {
    orderActivity: 'آرڈر کی سرگرمی',
    trend: 'آرڈرز اور ڈیلیوریز کا رجحان',
    totalQuantityOverTime: 'وقت کے ساتھ کل مقدار',
    quantityTrend: 'منتخب مدت میں ڈیلیور شدہ ٹن کا رجحان',
    orders: 'آرڈرز',
    tons: 'ڈیلیور شدہ ٹن',
  },

  rankings: {
    title: 'کارکردگی کی درجہ بندی',
    subtitle: 'بہترین کارکردگی دکھانے والی مصنوعات، صارفین اور ترسیل کے مقامات',
    topProducts: 'ٹاپ پروڈکٹس',
    topProductsByPackaging: 'پیکیجنگ کے لحاظ سے ٹاپ پروڈکٹس',
    topCustomers: 'کسٹمرز کی تقسیم',
    topCities: 'اعلی ترسیل کے شہر',
    deliveredTons: 'ڈیلیور شدہ ٹن',
    bulk: 'بلک',
    bags: 'بیگز',
    chartTypes: 'چارٹ',
    noData: 'منتخب مدت کے لیے کوئی ڈیٹا نہیں',
    marketShare: 'ٹاپ کسٹمرز کے لحاظ سے حجم کا حصہ',
    byTons: 'پیکیجنگ کی قسم کے لحاظ سے حجم کی تقسیم',
    deliveryLocations: 'ڈیلیوری کی جغرافیائی تقسیم',
    factoryPerformance: 'پلانٹ کی کارکردگی',
    factoryPerformanceDesc: 'فی پلانٹ ڈیلیوری کا حجم',
    clickForDetails: 'تفصیلات کے لیے پلانٹ پر کلک کریں',
    clickItemForDetails: 'تفصیلات کے لیے آئٹم پر کلک کریں',
  },

  factoryDrawer: {
    title: 'پلانٹ کی تفصیلات',
    overview: 'جائزہ',
    topProducts: 'ٹاپ پروڈکٹس',
    topCustomers: 'ٹاپ کسٹمرز',
    topCities: 'ٹاپ شہر',
    totalTons: 'کل ٹن',
    totalOrders: 'آرڈرز',
    totalProducts: 'پروڈکٹس',
    totalDeliveries: 'ڈیلیوریز',
    bulk: 'بلک',
    bags: 'بیگز',
    noData: 'کوئی ڈیٹا دستیاب نہیں',
    packagingBreakdown: 'پیکیجنگ کی تقسیم',
  },

  entityDrawer: {
    customerDetails: 'کسٹمر کی تفصیلات',
    productDetails: 'پروڈکٹ کی تفصیلات',
    cityDetails: 'شہر کی تفصیلات',
    topPlants: 'ٹاپ پلانٹس',
    topProducts: 'ٹاپ پروڈکٹس',
    topCustomers: 'ٹاپ کسٹمرز',
    topCities: 'ٹاپ شہر',
    overview: 'جائزہ',
    totalTons: 'کل ٹن',
    totalOrders: 'آرڈرز',
    totalProducts: 'پروڈکٹس',
    totalDeliveries: 'ڈیلیوریز',
    bulk: 'بلک',
    bags: 'بیگز',
    noData: 'کوئی ڈیٹا دستیاب نہیں',
    packagingBreakdown: 'پیکیجنگ کی تقسیم',
  },

  liveFeed: {
    title: 'فیکٹری میں لائیو',
    subtitle: '{{count}} گاڑیاں فی الحال فیکٹری میں ہیں',
    empty: 'ابھی فیکٹری میں کوئی گاڑی نہیں',
    lastUpdated: 'آخری اپ ڈیٹ: {{time}}',
    fields: {
      driver: 'ڈرائیور',
      factory: 'پلانٹ',
      product: 'پروڈکٹ',
    },
    status: {
      arrived: 'پہنچ گیا',
      loading: 'لوڈنگ',
      weighing: 'وزن ہو رہا ہے',
      completed: 'مکمل',
    },
  },

  quickActions: {
    title: 'فوری اعمال',
    newSalesOrder: 'نیا سیلز آرڈر',
    myOrders: 'میرے آرڈرز',
  },

  ordersValue: {
    title: 'آرڈرز کی قیمت (VAT سمیت)',
    subtitle: 'فعال آرڈرز کا مجموعہ 15% ٹیکس سمیت',
    beforeTax: 'ٹیکس سے پہلے',
    tax: 'VAT 15%',
    activeOrders: 'فعال آرڈرز',
  },

  customerBalance: {
    title: 'کسٹمر بیلنس',
    subtitle: 'آپ کے اکاؤنٹ پر دستیاب بیلنس',
  },

  balanceDiff: {
    title: 'بیلنس بمقابلہ آرڈرز',
    surplus: 'سرپلس',
    deficit: 'خسارہ',
  },

  units: {
    bulk: 'بلک',
    bags: 'بیگز',
  },

  currency: {
    sar: 'ر.س',
    usd: 'USD',
  },
}
